import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    SAVE_COMMENT: (substitutionId) => ({
        url: `substitutions/${substitutionId}/comments`,
        method: "post",
    }),

    SAVE_SHIFT_DATA: {
        url: "verzoeken/save-shift-data",
        method: "post",
    },

    UPDATE_DAY_PART_STATUS: {
        url: "verzoeken/scherm/update",
        method: "post",
    },

    UPDATE_WTF: {
        url: "verzoeken/scherm/updateWtf",
        method: "post",
    },

    GET_LONG_CONTRACT_ADMIN_LIST: (id) => ({
        url: `long-contract-admin-list/${id}`,
        method: "get",
    }),

    SAVE_LONG_CONTRACT: {
        url: "long-contract",
        method: "post",
    },

    UPDATE_LONG_CONTRACT: {
        url: "long-contract/update",
        method: "post",
    },

    GET_LONG_CONTRACT_DETAILS: (id) => ({
        url: `long-contract/${id}`,
        method: "get",
    }),

    MELDER_REMINDER: {
        url: 'update-melder-reminder',
        method: "post",
    },


    REMOVE_USER: {
        url: "verzoeken/remove-user",
        method: "post",
    },


    // ================= Chat =================

    UPDATE_MEMO: {
        url: "verzoeken/scherm/updateMemo",
        method: "post",
    },

    GET_SHIFT_LIST: {
        method: "get",
    },

    COMMENT_STATUS: {
        url: "verzoeken/scherm/changeArchiveStatus",
        method: "post",
    },

    DELETE_DAY_PARTS: {
        url: (dayPartId) => `/verzoeken/scherm/${dayPartId}/dates`,
        method: "get",
    }
};

// ================= Partials =================

export const useSaveComment = (substitutionId) =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_COMMENT(substitutionId));

export const useSaveShiftData = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_SHIFT_DATA);

export const useUpdateDayPartStatus = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_DAY_PART_STATUS);

export const useUpdateWtf = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_WTF);

export const useGetLongContractAdminList = (id) =>
    useApiFetcherSWR(
        id
            ? API_ENDPOINT.GET_LONG_CONTRACT_ADMIN_LIST(id)
            : null
    );

export const useSaveLongContract = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_LONG_CONTRACT);

export const useUpdateLongContract = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_LONG_CONTRACT);

export const useGetLongContractDetails = (id) =>
    useApiFetcherSWR(
        id ? API_ENDPOINT.GET_LONG_CONTRACT_DETAILS(id) : null
    );

export const useMelderReminder = () =>
    useApiFetcherSWR(API_ENDPOINT.MELDER_REMINDER);

export const useGetArchivedMessages = (substitutionId, type) => {
    const shouldFetch =
        substitutionId != null &&
        type !== "";

    return useApiFetcherSWR(
        shouldFetch
            ? {
                url: `verzoeken/scherm/comments/${substitutionId}/${type}`,
                method: "get",
            }
            : null,
        {
            dedupingInterval: 0,
        }
    );
};

export const useRemoveUser = () =>
    useApiFetcherSWR(API_ENDPOINT.REMOVE_USER);

export const useDeleteDayPart = (dayPartId) =>
    useApiFetcherSWR(
        dayPartId
            ? {
                ...API_ENDPOINT.DELETE_DAY_PARTS,
                url: API_ENDPOINT.DELETE_DAY_PARTS.url(dayPartId),
            }
            : null
    );
// ================= Chat =================

export const useUpdateMemo = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_MEMO);

export const useShiftList = (substitutionId, adminId) =>
    useApiFetcherSWR({
        url:
            substitutionId && adminId
                ? `verzoeken/scherm/shift/${substitutionId}/${adminId}`
                : null,
        method: "get",
    });

export const useCommentStatus = () =>
    useApiFetcherSWR(API_ENDPOINT.COMMENT_STATUS);

export default API_ENDPOINT;